import { useMemo } from 'react';
import type React from 'react';
import PratusSelect from 'components/DesignSystems/New/PratusSelect';
import { useGroupGuid } from 'components/IAP/hooks/commonHooks';
import { useListLayerNodes } from 'hooks/layerNode/useListLayerNodes';
import { LayerGroupDto, LayerNodeDto } from 'hooks/layerNode/types';

type CategorySelectProps = {
  value: string | null;
  onChange: (layerId: string | null) => void;
  label: string;
};

function hasFolder(
  group: LayerGroupDto
): group is LayerGroupDto & { folder: LayerNodeDto } {
  return group.folder != null;
}

export const CategorySelect: React.FC<CategorySelectProps> = ({
  value,
  onChange,
  label,
}) => {
  const groupGuid = useGroupGuid();
  const { data } = useListLayerNodes(
    {
      filter: {
        groupGuid: groupGuid ?? '',
      },
    },
    { enabled: Boolean(groupGuid) }
  );

  const options = useMemo(() => {
    const layerNodeGroups = data?.data ?? [];

    return layerNodeGroups.filter(hasFolder).map((group) => ({
      value: group.folder.id,
      label: group.folder.name,
    }));
  }, [data?.data]);

  const selectedOption = value
    ? options.find((option) => option.value === value)
    : undefined;

  return (
    <PratusSelect
      label={label}
      options={options}
      value={selectedOption}
      onChange={(option) => {
        if (!option) {
          onChange(null);
          return;
        }

        if ('value' in option) {
          onChange(option.value as string);
        }
      }}
      isClearable
    />
  );
};
